enum LineHeight {
  NORMAL = 'normal',
  MID = '3.5rem',
  LOW = '2.7rem',
}

export default LineHeight;
